<script lang="ts" setup>
const { modals, triggerClose, triggerSuccess } = useOverlays()
const { t } = useI18n()
const route = useRoute()

watch(
  () => route.name,
  () => triggerClose({ modal: 'auth' }),
)

function onAuthenticated() {
  triggerSuccess({ modal: 'auth' })
}

function onClose() {
  triggerClose({ modal: 'auth' })
}
</script>

<template>
  <UModal
    :prevent-close="!modals.auth.closable"
    :ui="{ width: 'sm:max-w-xl' }"
    @close="onClose"
  >
    <UCard
      :ui="{
        body: {
          base: 'grid max-h-[calc(60vh)] overflow-y-auto py-10',
          padding: 'p-6 md:p-8',
        },
        header: {
          base: 'p-6 md:p-8',
        },
      }"
    >
      <template #header>
        <BaseQuote
          character="power"
          size="sm"
        >
          <div class="flex flex-col gap-1">
            {{ t(`titles.${modals.auth.title || 'default'}`) }}

            <template v-if="['datapoints', 'moreResults'].includes(modals.auth.title)">
              <span class="flex gap-1 text-sm text-gray-500">
                <BaseCoin
                  :credits="500"
                  hide-suffix
                />

                <AnimateRadiantText>
                  {{ t('creditsIncluded') }}
                </AnimateRadiantText>
              </span>
            </template>
          </div>
        </BaseQuote>
      </template>

      <AuthBox
        v-model:current-view="modals.auth!.data!.currentView"
        size="lg"
        @authenticated="onAuthenticated"
      />
    </UCard>
  </UModal>
</template>

<i18n lang="json">
{
  "en": {
    "creditsIncluded": "credits included to find your first customers.",
    "titles": {
      "companyProfile": "You need to sign up or log in to display all the information about the company.",
      "datapoints": "Unlock all our datapoints by signing up.",
      "default": "Create your account or login in one single click.",
      "moreResults": "Unlock all available results by signing up."
    }
  },
  "es": {
    "creditsIncluded": "créditos incluidos para encontrar tus primeros clientes.",
    "titles": {
      "companyProfile": "Necesitas registrarte o iniciar sesión para mostrar toda la información de la empresa.",
      "datapoints": "Desbloquea todos nuestros puntos de datos registrándote.",
      "default": "Crea tu cuenta o inicia sesión con un solo clic.",
      "moreResults": "Desbloquea todos los resultados disponibles registrándote."
    }
  },
  "fr": {
    "creditsIncluded": "crédits inclus pour trouver vos premiers clients.",
    "titles": {
      "companyProfile": "Vous devez vous inscrire ou vous connecter pour afficher toutes les informations sur l'entreprise.",
      "datapoints": "Débloquez tous nos points de données en vous inscrivant.",
      "default": "Créez votre compte ou connectez-vous en un seul clic.",
      "moreResults": "Débloquez tous les résultats disponibles en vous inscrivant."
    }
  }
}
</i18n>
